import { PUBLICATION } from "../actions/Actions";

const initalState = {
  listLoader: false,
  listCount: null,
  list: [],
  detailLoader: false,
  detail: null,
};

export function publicationReducer(state = initalState, action) {
  const { type, payload } = action;

  switch (type) {
    case PUBLICATION.LOADING:
      return {
        ...state,
        listLoader: true,
      };
    case PUBLICATION.SUCCESS:
      return {
        ...state,
        listLoader: false,
        listCount: payload.total,
        list: payload.rows,
      };
    case PUBLICATION.ERROR:
      return {
        ...state,
        listLoader: false,
      };
    default:
      return state;
  }
}
